import { NgModule } from '@angular/core';

import { CapitalizePipe } from './pipes';
import { NumberFormatted } from './number-formatted.pipe';

@NgModule({
  declarations: [NumberFormatted, CapitalizePipe],
  exports: [NumberFormatted, CapitalizePipe],
})
export class PipesModule {}
